import Axios from "axios";
import { useEffect, useState } from "react";
import { useGlobalContext } from "./context";
import { totalAmount } from "../utils/amount";
import axios from "../utils/axios";
import generateReferenceID from "../utils/generateReferenceID";

const {
  REACT_APP_MOSJID_NAME: mosjidName,
  REACT_APP_PAYMENT_URL: paymentUrl,
  REACT_APP_PAYMENT_NAME: paymentName,
  REACT_APP_PAYMENT_MERCHANT_ID: merchantID,
} = process.env;

const registerID = JSON.parse(localStorage.getItem("registerId")) || "";

function useTestPayment() {
  const [message, setMessage] = useState("");
  const [server, setServer] = useState(false);
  const [payment, setPayment] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const { selectedItems, emptySelectedItems } = useGlobalContext();

  const amount = totalAmount(selectedItems);

  const onPayment = async (argAmount) => {
    setMessage("Please follow the instructions on the terminal.");
    try {
      let url = `${paymentUrl}/api/v2/purchase/${paymentName}`;
      const { data } = await Axios.post(url, {
        reference_id: generateReferenceID(),
        merchant_id: merchantID,
        register_id: registerID,
        total_amount: argAmount ? argAmount : amount,
        cash_amount: null,
        mm_account_index: null,
        pos_prints_receipt: true,
      });
      console.log("data", data);
      if (data.result?.toLowerCase() === "failure") {
        setMessage(data.final_message);
      } else {
        setMessage(data.result);
        setServer(true);
        setPayment(data);
      }
    } catch (err) {
      setMessage(err?.response?.data?.title || "Something went wrong!");
      if (argAmount) {
        emptySelectedItems();
      }
      // setMessage("There was an error occured!");
    }
  };

  useEffect(() => {
    async function addPayment() {
      try {
        const res = await axios.post(
          "/add/payment",
          {
            payment: payment,
            items: selectedItems,
            mosjidName: mosjidName,
          },
          {
            headers: {
              "Access-Control-Allow-Origin": "*",
              "Content-Type": "application/json",
            },
          }
        );
        if (res.data) {
          emptySelectedItems();
          setServer(false);
          setPayment(null);
          setPaymentId(res.data.paymentId);
        }
      } catch (error) {
        console.log("Server Error: ", error);
        emptySelectedItems();
        setServer(false);
        setPayment(null);
      }
    }

    if (server && selectedItems.length > 0) {
      addPayment();
    }
  }, [server, selectedItems, payment, emptySelectedItems]);

  const onClose = () => {
    setMessage("");
    setServer(false);
    setPayment(null);
    setPaymentId(null);
  };

  return {
    message,
    onPayment,
    onClose,
    paymentId,
  };
}

export default useTestPayment;
